import React from 'react'
import Helmet from 'react-helmet'
import Pricing from '../Pricing'
import PropTypes from 'prop-types'

import Compren from '../../../static/img/compren.jpeg'

const PricingPageTemplate = (props) => {
  const { title, meta_title, meta_description, pricing } = props

  return (
    <div>
      <Helmet>
        <title>{meta_title}</title>
        <meta name='description' content={meta_description} />
      </Helmet>
      <section
        className='hero is-fullheight' style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)), url(${Compren})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',

        }}>
        <div className='hero-body'>
          <div className='container'>
            <h1 className='title has-text-white'>
              STORE
            </h1>
            <h2 className='subtitle has-text-white'>
              Soon            </h2>
          </div>
        </div>
      </section>
      <section className='section section--gradient'>
        <div className='container'>
          <div className='section'>
            <div className='columns'>
              <div className='column is-10 is-offset-1'>
                <div className='content'>
                  <h2 className='has-text-weight-semibold is-size-2' />
                  <p> Caution! This Page is Cordoned Off
                    The earthquake was not good to the bike lane on your way to work.
                    A large gap in the pavement (too big to be called a pothole) had swallowed three
                    oblivious bikers whole. So the city had put up two pylons and yellow caution tape.
                    Pretty frustrating for you given your propensity to do 360 jumps over the gap.</p>
                  {/* <p className='is-size-5'>{pricing.description}</p> */}
                  <Pricing data={pricing.plans} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
PricingPageTemplate.propTypes = {
  title: PropTypes.string,
  meta_title: PropTypes.string,
  meta_description: PropTypes.string,
  pricing: PropTypes.shape({
    heading: PropTypes.string,
    description: PropTypes.string,
    plans: PropTypes.array,
  }),
}

export default PricingPageTemplate
